import { Box, Tab } from "@mui/material";
import { useTranslation } from "next-i18next";
import { IWikifolioKeyFigureGroup } from "src/api/server/wf-detail.types";
import { WfHeading } from "src/components-mui/base/wf-heading/wf-heading";
import { KeyFigureGroup } from "src/components-mui/pages/detail/key-figures/components/key-figure-group";
import { TabPanel } from "src/components-mui/tabs/tab-panel";
import { TabsContext } from "src/components-mui/tabs/tabs-context";
import { TabsList } from "src/components-mui/tabs/tabs-list";

interface IOtherRiskIndicatorsProps {
    keyFigureGroups: IWikifolioKeyFigureGroup[];
}

export const OtherRiskIndicators = ({ keyFigureGroups }: IOtherRiskIndicatorsProps) => {
    const { t } = useTranslation("wf-detail");

    return (
        <>
            <WfHeading component="h3" fontSize="md" sx={{ mb: 2 }}>
                {t("headlines.other-key-risk-indicators")}
            </WfHeading>
            <Box sx={{ mb: 5 }}>
                <TabsContext initialValue={0}>
                    <TabsList customVariant="full">
                        {keyFigureGroups.map(keyFigureGroup => (
                            <Tab key={keyFigureGroup.label} label={keyFigureGroup.label} sx={{ lineHeight: 1.5 }} />
                        ))}
                    </TabsList>
                    <Box sx={{ mt: 2 }}>
                        {keyFigureGroups.map((keyFigureGroup, index) => (
                            <TabPanel key={keyFigureGroup.label} value={index}>
                                <KeyFigureGroup keyFigureGroup={keyFigureGroup} />
                            </TabPanel>
                        ))}
                    </Box>
                </TabsContext>
            </Box>
        </>
    );
};
